module.exports = __webpack_public_path__ + "images/stickers/pete-confused.0d52a88328d4c0196564.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/pete-confused.png
// module id = hRoZ
// module chunks = 13